import React from "react";
import {BoxIsolatedContent, ContentTop16, FlexColumn, FlexColumnCentered} from "../../components/ui/Content";
import {LogoId} from "../../icon/Icon";
import {Subhead2} from "../../components/Font";
import {ButtonPrimary} from "../../components/ui/Button";
import {LocalStorageEnum} from "../../enum/localStorage";
import {LanguageSelector} from "../Auth/LanguageSelector";
import {useLocation, useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export const NotFound = () => {
    const {t} = useTranslation();
    const navigate = useNavigate()
    const {search} = useLocation()
    return <div className={'background body1'}>
        <FlexColumnCentered className={'box-isolated'}>
            <BoxIsolatedContent>
                <LogoId/>
                <FlexColumn>
                    <ContentTop16>
                        <h1 style={{fontSize: 42, fontWeight: 'normal'}}>404</h1>
                    </ContentTop16>
                    <ContentTop16>
                        <Subhead2> {t('auth.pageNotFound')}</Subhead2>
                    </ContentTop16>
                </FlexColumn>

                <ButtonPrimary onClick={() => {
                    localStorage.setItem(LocalStorageEnum.sawUpdate, 'true')
                    navigate(`/sign-in${search}`)
                }
                }>{t('auth.returnToPassport')}
                </ButtonPrimary>
            </BoxIsolatedContent>
            <LanguageSelector/>
        </FlexColumnCentered>
    </div>
}
